import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetSysAppLoggerSaga() {
    yield put(appActions.SYSAPPLOGGER_RESET_SUCCESS());
}

function* watchSysAppLoggerUpdateRequest() {
    yield takeLatest(
        appActions.SYSAPPLOGGER_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/system/app-logs/update',
                appActions.SYSAPPLOGGER_UPDATE_SUCCESS,
                appActions.SYSAPPLOGGER_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchSysAppLoggerCreateRequest() {
    yield takeLatest(
        appActions.SYSAPPLOGGER_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/system/app-logs/save',
                appActions.SYSAPPLOGGER_CREATE_SUCCESS,
                appActions.SYSAPPLOGGER_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchSysAppLoggerDeleteRequest() {
    yield takeLatest(
        appActions.SYSAPPLOGGER_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/system/app-logs/delete',
                appActions.SYSAPPLOGGER_DELETE_SUCCESS,
                appActions.SYSAPPLOGGER_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchSysAppLoggerGetAllRequest() {
    yield takeLatest(
        appActions.SYSAPPLOGGER_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/system/app-logs/filter',
                appActions.SYSAPPLOGGER_GET_ALL_SUCCESS,
                appActions.SYSAPPLOGGER_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* sysAppLoggerWatcher() {
    yield* watchSysAppLoggerUpdateRequest();
    yield* watchSysAppLoggerCreateRequest();
    yield* watchSysAppLoggerGetAllRequest();
    yield* watchSysAppLoggerDeleteRequest();
    yield takeLatest(appActions.SYSAPPLOGGER_RESET_REQUEST.type, resetSysAppLoggerSaga);
    // Add other watchers here
}
